import type { FC } from 'react';
import { useStoreState } from 'easy-peasy';
import { selectorUser } from '@model/User';
import { USER_TYPES_MAP } from '@app/constants/session';
import { useParams } from 'react-router-dom';
import { candidateSelector } from '@model/Candidate/Candidate.selectors';
import type { TProfileInfoHeaderRouteParams } from '@components/Molecules/ProfileInfoHeader/ProfileInfoHeader.types';
import {
  ACTION_VARIANTS,
  Avatar,
  ICON_NAMES,
  Link,
} from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';

export const ProfileInfoHeader: FC = () => {
  const { t } = useTranslation();
  const { type: userType } = useStoreState(selectorUser);
  const candidate = useStoreState(candidateSelector);
  const { jobId, candidateId } = useParams<TProfileInfoHeaderRouteParams>();

  if (!jobId || !candidateId || !candidate) {
    return null;
  }

  const isUserManager = userType === USER_TYPES_MAP.MANAGER;
  const editCandidateLink = `${__ENVIRONMENT_CONFIG__.API_HOST}/dashboard/recruitment/jobs/${jobId}/candidates/${candidateId}/edit`;

  return (
    <div className="c-profile-info-header">
      <div className="c-profile-info-header__intro">
        <Avatar
          className="c-profile-info-header__avatar"
          src={candidate.avatarUrl ?? undefined}
          size={96}
        />

        {isUserManager && (
          <Link
            className="c-profile-info-header__edit-link"
            href={editCandidateLink}
            leftIcon={ICON_NAMES.EDIT}
            target="_blank"
            variant={ACTION_VARIANTS.SIMPLE_TEXT}
          >
            {t('candidateDetails.intro.editLink')}
          </Link>
        )}
      </div>

      <div className="c-profile-info-header__headings">
        <h1 className="c-profile-info-header__full-name">
          {t('common.formatting.fullName', { ...candidate })}
        </h1>

        <p className="c-profile-info-header__job-title">
          {candidate.currentJobTitle}
        </p>
      </div>
    </div>
  );
};
